import Vue from 'vue';
import Vuex from 'vuex';

import indentV2 from '@/modules-v2/indent/store/';
import exim from '@/modules-v2/exim/exim_store';

import app from './modules/app/';
import order from './modules/order/';
import routes from './modules/routes/';
import dashboard from './modules/dashboard/';
import settings from './modules/settings/';
import role from './modules/role/';
import depot from './modules/depot/';
import mdm from './modules/mdm/';
import mdmV2 from './modules/mdm-v2/';
import pod from './modules/pod/';
import podAiValidation from './modules/podAiValidation';
import invoice from './modules/invoice/';
import paymentsV2 from './modules/payments-v2/';
import optima from './modules/optima/';
import report from './modules/report/';
import wallet from './modules/wallet/';
import walletV2 from './modules/wallet-v2/';
import track from './modules/track/';
import freight from './modules/freight';
import riq from './modules/riq';
import procure from './modules/procure';
import planning from './modules/planning';
import transporterSettings from './modules/transporter-settings';
import paySettlement from './modules/pay-settlement';

import createLogger from 'vuex/dist/logger';

const debug = process.env.NODE_ENV !== 'production';
const plugins = debug ? [createLogger({})] : [];

Vue.use(Vuex);

function enableNamespacedModule() {
  const modules = {
    app,
    order,
    dashboard,
    mdm,
    mdmV2,
    pod,
    podAiValidation,
    routes,
    settings,
    depot,
    role,
    invoice,
    paymentsV2,
    optima,
    report,
    wallet,
    walletV2,
    track,
    freight,
    riq,
    indentV2,
    exim,
    procure,
    transporterSettings,
    planning,
    paySettlement,
  }; // add new modules here;
  const keys = Object.keys(modules);
  keys.forEach((module) => {
    modules[module].namespaced = true;
  });
  return modules;
}

const modules = enableNamespacedModule();
export default new Vuex.Store({ modules, strict: debug, plugins });
